<template>
  <v-card class="rounded-card card-shadow mt-3">
    <v-tabs v-model="tab">
      <v-tab class="small-spacing">Local de Entrega</v-tab>
      <v-tab class="small-spacing">Local de Faturamento</v-tab>
      <v-tab class="small-spacing">Links</v-tab>
    </v-tabs>
    <v-divider/>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card
          flat
          class="rounded-card"
        >
          <v-card-text class="text--primary">
            <px-aprovacao-detalhes-comprador is-entrega :aprovacao="aprovacao"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card
          flat
          class="rounded-card"
        >
          <v-card-text class="text--primary">
            <px-aprovacao-detalhes-comprador :aprovacao="aprovacao"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card
          flat
          class="rounded-card"
        >
          <v-card-text class="text--primary">
            <px-aprovacao-detalhes-links :aprovacao="aprovacao"/>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import pxAprovacaoDetalhesComprador from './AprovacaoDetalhesComprador.vue';
import pxAprovacaoDetalhesLinks from './AprovacaoDetalhesLinks.vue';

export default {
  props: {
    aprovacao: Object,
  },
  data() {
    return {
      tab: 0,
    };
  },
  components: { pxAprovacaoDetalhesComprador, pxAprovacaoDetalhesLinks },
};
</script>
